
import styled from 'styled-components';
import devices from '@/utilities/devices';
import { transformTitleToAnchorId } from '@/utilities/functions';
// import React from 'react'

// #region STYLE
const SummaryContainer = styled.div`
	padding: 2.5rem 0;

	.title {
		font-size: ${({ theme }) => theme.fontSize.XXLARGE};
		color: ${({ theme }) => theme.color.prune};
		font-weight: bold;
		margin-bottom: 1.25rem;
	}

	@media screen and (${devices.mobile}) {
		.title {
			text-align: center;
		}
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		.title {
			text-align: center;
		}
	}
`;

const LinksContainer = styled.div`
	ol {
		li {
			a {
				color: ${({ theme }) => theme.color.black};
				display: inline-block;
				padding: .1rem .2rem;
				text-decoration: none;
				transition: .3s;

				:after {
					background-color: ${({ theme }) => theme.color.prune};
					content: '';
					display: block;
					height: 1px;
					margin-top: -3px;
					opacity: 0;
					transition: .2s;
					width: 85%;
				}

				:hover {
					color: ${({ theme }) => theme.color.prune};
					:after {
						opacity: 1;
						width: 100%;
					}
				}
			}
			:before {
				content: '';
       			margin-left: 4px;
			}
		}

		.li-firstLevel {
			padding: .5rem 0;
		}

		> ol {
			margin: 0rem 0 1rem;
		}
	}

	@media screen and (${devices.mobile}) {
		> ol {
			padding: 0 1rem;
			li {
				:before {
					content: '';
					margin-left: 0px;
				}
				a {
					:hover {
						:after {
							opacity: 0;
						}
					}
					display: inline-block;
					vertical-align: top;
				}
			}
			> ol > li {
				padding: .2rem 0;
			}
		}
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		> ol {
			padding: 0 1rem;
			li {
				:before {
					content: '';
					margin-left: 0px;
				}
				a {
					:hover {
						:after {
							opacity: 0;
						}
					}
					display: inline-block;
					vertical-align: top;
				}
			}
			> ol > li {
				padding: .2rem 0;
			}
		}
	}
`;
// #endregion

const Summary = ({ summary }: {
	summary?: string[],
}) => {

	return (
		<SummaryContainer>
			<div className='title'>
				Sommaire
			</div>
			{summary && (
				<LinksContainer>
					<ol>
						{summary.map(
							(title: string) => (
								<li className='li-firstLevel' key={title}>
									<a href={`#${transformTitleToAnchorId(title)}`}>
										{title}
									</a>
								</li>
							),
						)}
						{/* {summary.map(
							(link, index) => (
								link.subtitles ? (
									<React.Fragment key={index}>
										<li className='li-firstLevel'>
											<a href={`#${transformTitleToAnchorId(link.title)}`}>
												{link.title}
											</a>
										</li>
										<ol type='a'>
											{link.subtitles.map(
												(subtitle, index_subtitle) => (
													<li key={index_subtitle}>
														<a href={`#${transformTitleToAnchorId(subtitle.subtitle)}`}>
															{subtitle.subtitle}
														</a>
													</li>
												),
											)}
										</ol>
									</React.Fragment>
								) : (
									<li className='li-firstLevel' key={index}>
										<a href={`#${transformTitleToAnchorId(link.title)}`}>
											{link.title}
										</a>
									</li>
								)
							),
						)} */}
					</ol>
				</LinksContainer>
			)}
		</SummaryContainer>
	);
};

export default Summary;
